import { TextField } from '@/components/form/fields/text/TextInput';
import { FunctionComponent } from 'react';

interface ContactInformationFieldProps {
  fieldKey?: string;
  readonly?: boolean;
}

const ContactInformationField: FunctionComponent<ContactInformationFieldProps> = ({ fieldKey = '', readonly }) => {
  const fieldPrefix = fieldKey ? `${fieldKey}.` : '';

  return (
    <div className="flex flex-col space-y-1">
      <div className="flex flex-row space-x-5">
        <TextField className="flex-1" readonly={readonly} id={`${fieldPrefix}contact.workEmail`} label="Work Email" />
        <TextField
          className="flex-1"
          readonly={readonly}
          id={`${fieldPrefix}contact.personalEmail`}
          label="Personal Email (for new hires)"
          optional
        />
      </div>
      <div>
        <TextField readonly={readonly} id={`${fieldPrefix}contact.telephoneNumber`} label="Telephone Number" />
      </div>
    </div>
  );
};

export default ContactInformationField;
